import { MapPin, Users } from "lucide-react";
import { useLanguage } from "@/lib/useLanguage";
import { conversionCopy } from "@/lib/conversionCopy";

const Testimonials = () => {
  const { language } = useLanguage();
  const copy = conversionCopy[language];
  return (
    <section className="bg-card py-8 lg:py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-[40px] font-bold text-primary text-center mb-10">{copy.trustHeading}</h2>
        <div className="grid grid-cols-3 gap-3 text-center mb-10">
          {["2000+", "40+", "98%"].map((number, i) => (
            <div key={number}><p className="text-3xl md:text-4xl font-bold text-primary mb-2">{number}</p><p className="text-sm text-muted-foreground">{copy.stats[i]}</p></div>
          ))}
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-background rounded-xl p-6"><Users className="text-primary mb-4" /><h3 className="font-bold mb-2">{copy.team}</h3><p className="text-muted-foreground">{copy.teamBody}</p></div>
          <div className="bg-background rounded-xl p-6"><MapPin className="text-primary mb-4" /><h3 className="font-bold mb-2">{copy.address}</h3><p className="text-muted-foreground">{copy.appointment}</p></div>
        </div>
        <p className="text-sm text-muted-foreground text-center mt-6">{copy.disclaimer}</p>
      </div>
    </section>
  );
};
export default Testimonials;
